import { gridCells, gridLayout, pageGrid } from "./dashboardCanvas"
import { widgetMinCells } from "./tokens/layout"

export function constrainReportLayout(layout, canvas) {
  const w = Math.min(canvas.width, Math.max(80, Number(layout.w) || 80))
  const h = Math.min(canvas.height, Math.max(50, Number(layout.h) || 50))
  return { x: Math.max(0, Math.min(canvas.width - w, Number(layout.x) || 0)), y: Math.max(0, Math.min(canvas.height - h, Number(layout.y) || 0)), w, h }
}

// Grid version of constrainReportLayout for report pages with the Grid on: whole
// cells, at least the widget type's minimum, and inside the page's row budget.
export function constrainReportGridLayout(layout, canvas, widget) {
  const grid = pageGrid(canvas)
  const min = widgetMinCells(widget?.type, widget)
  const cells = gridCells(layout, grid, { c: Math.min(grid.cols, min.c), r: Math.min(grid.rows, min.r) }, widget?.type === "header")
  const rows = Math.min(cells.rows, grid.rows)
  const row = Math.max(0, Math.min(cells.row, grid.rows - rows))
  return gridLayout({ ...cells, rows, row, top: row === cells.row ? cells.top : undefined }, grid)
}

// A widget whose bottom edge passes the page bottom is off-page: dimmed in the
// editor and left out of the PDF (summer "off-page veil").
export function reportWidgetOffPage(layout, canvas) {
  return Number(layout?.y) + Number(layout?.h) > (Number(canvas?.height) || 794) + 0.5
}

export function copyReportPage(page) {
  const copy = structuredClone(page)
  return { ...copy, id: crypto.randomUUID(), widgets: copy.widgets.map((widget) => ({ ...widget, id: crypto.randomUUID() })) }
}
